import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { MenuCategoriesService } from './services/menu-categories.service';
import { MenuCategoriesEffects } from './store/menu-categories.effects';
import { MenuCategoriesReducer } from './store/menu-categories.reducer';

import { PageTitleService } from '@layout/ui/services/page-title.service';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        TranslateModule.forChild(),
    ],
    providers: [
        provideState({ name: 'menuCategories', reducer: MenuCategoriesReducer }),
        provideEffects(MenuCategoriesEffects),
        MenuCategoriesService,
        PageTitleService,
    ],
    exports: [],
})
export class MenuCategoriesModule { }
